import {ApplicationTypeConstants} from './../../services/warmup/warmup.service';
import {ApplicationValue} from 'app/services/warmup/application-type.model';
import {Pipe, PipeTransform, OnInit} from "@angular/core/";
import {WarmUpService} from 'app/services/warmup/warmup.service';
import {Observable} from 'rxjs/Observable';
import {EntityRelationsService} from '../../entities/relations/entity-relations.service';

@Pipe({
  name: 'ApplicationValueNameFromId'
})
export class ApplicationValueName implements PipeTransform {

  constructor(private warmupService: WarmUpService) {
  }

  transform(valueId: number, type: string): string {
    let applicationValues: ApplicationValue[]  = this.getValues(type);
    if (applicationValues) {
      return applicationValues.find(value => value.id == valueId).name;
    } else {
      return "";
    }
  }

  getValues(applicationType: string): ApplicationValue[] {
    const values = this.warmupService.getApplicationValue(applicationType);
    if (values instanceof Observable) {
      values.subscribe(
        response => {
          this.warmupService.setApplicationTypeInLS(response);
        }
      );
    } else {
      return values;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/application.value.pipe.ts